import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { AppProviders } from "@components/AppProviders";
import ErrorPage from "@pages/ErrorPage";
import { routeConfig } from "./routes/routeConfig";
import { DevCockpitProvider } from "@features/dev-cockpit";
import { useAutoUpdate } from "@shared/hooks/useAutoUpdate";
import { useEffect, useRef } from "react";

if (import.meta.env.DEBUG === 'true') {
  import("@features/dev-cockpit/services/global-network-interceptor").then(
    (m) => m.installGlobalFetchInterceptor()
  );
}

function AutoUpdateOnNavigation() {
  const location = useLocation();
  const { onRouteChange } = useAutoUpdate();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    onRouteChange();
  }, [location.pathname, onRouteChange]);

  return null;
}

function AppContent() {
  return (
    <>
      <AutoUpdateOnNavigation />
      <Routes>
        {routeConfig.map((route, index) => (
          <Route
            key={`route-${route.stepNumber}-${index}`}
            path={route.path}
            element={route.element}
          />
        ))}
        <Route
          path="*"
          element={<ErrorPage errorType="route" />}
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AppProviders>
      <AppContent />
      <DevCockpitProvider />
    </AppProviders>
  );
}

export default App;

